// Set copyright year to 2025 (when YogaBuild started)
(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        const yearElement = document.getElementById('copyright-year');
        if (yearElement) {
            yearElement.textContent = '2025';
        }
    });
})();
